/** Placeholder for an empty cell — a dash reads better than a blank cell (shared coordinator/volunteer behaviour). */
const EMPTY_CELL_PLACEHOLDER = '-';

/**
 * Single-line cell text that clips with an ellipsis and exposes the full value via the title tooltip,
 * shared by the volunteer and coordinator shift tables. TruncatedText is a throwing stub in
 * @amzn/awsui-components-react, so truncation is done in CSS. The span fills its cell (maxWidth: 100%)
 * and clips there, so it tracks the column's CURRENT width: both tables enable resizableColumns, so
 * dragging the Shift Name column wider reveals more of the name and narrower keeps the ellipsis clean.
 * A fixed px cap would instead freeze the visible text regardless of the resized width. An
 * empty/whitespace value renders the dash placeholder rather than a blank cell.
 */
export function TruncatedCellText({ text }: { text?: string }) {
  if (!text?.trim()) return <>{EMPTY_CELL_PLACEHOLDER}</>;
  return (
    <span
      title={text}
      style={{
        display: 'block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </span>
  );
}
